// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"56":"Reports","472":"Auditing","515":"Configuration","672":"Configurator","757":"Status","961":"Users","974":"Nodes"}[chunkId] + "." + {"56":"72a269e0","472":"64956fea","515":"4fd6b744","672":"d21b32a5","757":"c6fbedd1","961":"fcb134f7","974":"8137177f"}[chunkId] + ".css";
};